/** Тот же самый ValidationMixin только адаптированный под новый компонент VForm */
const ValidationFormMixin = {
	data() {
		return {
			formEl: null,
		};
	},

	mounted() {
		this.formEl = this.$refs.form ?? null;
	},

	computed: {
		isValid() {
			return this.formEl?.isValid;
		},
	},

	methods: {
		validate() {
			if (!this.formEl) {
				this.formEl = this.$refs.form;
			}

			if (!this.formEl) {
				throw new Error('VForm ref="form" не найден в компоненте');
			}

			return this.formEl.validate();
		},

		scrollToError() {
			if (this.formEl.invalidControls.size === 0) {
				return;
			}

			const nextInvalidControlUid = this.formEl.invalidControls.keys()
				.next().value;

			if (!nextInvalidControlUid) {
				return;
			}

			this.formEl.controls.get(nextInvalidControlUid)
				.$el
				.scrollIntoView({
					behavior: 'smooth',
					block:    'center',
				});
		},
	},
};

export default ValidationFormMixin;
